import { IImageFactory } from './IImageFactory';
import { IImage } from './IImage';
import { BrowserImage } from './BrowserImage';

export class BrowserImageFactory implements IImageFactory {
  public fromVideoElement(video: HTMLVideoElement): IImage {
    const canvas = document.createElement('canvas');

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Failed to get canvas context');
    }

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    return new BrowserImage(canvas.toDataURL());
  }

  public fromDataUrl(dataUrl: string): IImage {
    return new BrowserImage(dataUrl);
  }

  public async fromFile(file: File): Promise<IImage> {
    const dataUrl = await this.readFileAsDataUrl(file);
    return new BrowserImage(dataUrl);
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as data URL'));
        }
      };
      reader.onerror = (e) => reject(e);
      reader.readAsDataURL(file);
    });
  }
}